<div class="card-body show-on-phone">
  <h2>uw scherm is niet breed genoeg voor deze pagina</h2>
  <p>maak uw browservenster groter of gebruik een groter scherm</p>
  <div class="spacer-small"></div>
  <span routerLink="/" class="btn arrow-left btn-left">terug</span>
</div>
